import {ClientReportSubmitInput, ReportServiceType, serviceTypeMapping} from "../../domain";
import {Controller, useFormContext} from "react-hook-form";
import {DropdownMultiSelect} from "../../../../common";
import {SPLIT_DELIMITER, splitAndRemoveEmpty} from "../../../../placement/const";
import React, {useCallback} from "react";
import _ from "lodash";

const theServiceTypeMap = new Map<string, string>(Object.entries(serviceTypeMapping));
const serviceTypeOptions = Array.from(theServiceTypeMap.keys());

const validCombosBhpnpp1858 = [
    [ReportServiceType.ABA_Parent_Training, ReportServiceType.Social_Skills_Group],
    [ReportServiceType.Parent_Led_ABA, ReportServiceType.Group_ABA],
    [ReportServiceType.Parent_Led_ABA, ReportServiceType.Social_Skills_Group],
    [ReportServiceType.Traditional_ABA, ReportServiceType.Group_ABA],
    [ReportServiceType.Traditional_ABA, ReportServiceType.Parent_Led_ABA],
    [ReportServiceType.Traditional_ABA, ReportServiceType.Social_Skills_Group],
    [ReportServiceType.ThreeTierOrParentTraining, ReportServiceType.Social_Skills_Group],
    [ReportServiceType.ThreeTierOrParentTraining, ReportServiceType.Group_ABA],
    [ReportServiceType.ThreeTierOrParentLed, ReportServiceType.Social_Skills_Group],
    [ReportServiceType.ThreeTierOrParentLed, ReportServiceType.Group_ABA],
];

function shouldDisableServiceType(checked: string[], option: string) {
    if (checked.length === 0) {
        return false;
    }

    if (checked.includes(option)) {
        return false;
    }

    let isOptionAPartialCombo = false;

    for (const combo of validCombosBhpnpp1858) {
        const matched = _.intersection(checked, combo);
        const matches = matched.length;
        if (matches === combo.length) {
            return true;
        }
        if (matches > 0 && combo.includes(option as ReportServiceType)) {
            isOptionAPartialCombo = true;
        }
    }

    return !isOptionAPartialCombo;
}

type ServiceTypeInputProps = {
    disabled: boolean;
};

export function ServiceTypesMultiselectInput({disabled}: ServiceTypeInputProps) {
    const {
        setValue,
        clearErrors,
        control,
        formState: {
            errors
        },
    } = useFormContext<ClientReportSubmitInput>();
    const disableFunc = useCallback((checked: string[], option: string) => disabled
        ? true
        : shouldDisableServiceType(checked, option),
        [disabled]
    );

    return (
        <div className="text-black-200 pb-2 text-base">
            <div className="flex">
                <div className="flex items-center">
                    Service Types
                </div>
                <div className="ml-4 items-center">
                    <Controller
                        name="serviceType"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={({field: {value}}) => {

                            return (
                                <DropdownMultiSelect
                                    field='serviceType'
                                    disabled={disabled}
                                    options={serviceTypeOptions}
                                    labelMapperFunc={(val) => theServiceTypeMap.get(val)!}
                                    value={(value ?? []).join(SPLIT_DELIMITER)}
                                    setValue={(values) => {
                                        setValue("serviceType", splitAndRemoveEmpty(values));
                                        clearErrors("serviceType");
                                    }}
                                    disableFunc={disableFunc}
                                    hasError={errors.serviceType !== undefined}
                                />
                            );
                        }}/>
                </div>
            </div>

            {
                errors.serviceType &&
                <div className="text-red-700">
                    Please select “Service Type” before submitting
                </div>
            }
        </div>
    );
}
